// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"3f0b007e","158":"85748c39","178":"85748c39","419":"85748c39"}[chunkId] + ".chunk.css";
};